<template>
  <b-container class="p-3">
    <b-row>
      <b-col>
        <b-form-input
          v-model="form_data.old_pw"
          id="input-old-pw"
          placeholder="Old Password"
          type="password"
        />
      </b-col>
    </b-row>

    <b-row class="mt-3">
      <b-col>
        <b-form-input
          v-model="form_data.new_pw"
          id="input-new-pw"
          placeholder="New Password"
          type="password"
        />
      </b-col>
    </b-row>

    <b-row class="mt-3">
      <b-col>
        <b-form-input
          v-model="form_data.confirm"
          id="input-confirm"
          placeholder="Confirm Password"
          type="password"
        />
      </b-col>
    </b-row>

    <b-row class="mt-5">
      <b-col cols="6">
        <b-button variant="primary" block @click="updatePWCS">
          Change Password
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
// external dependencies
import swal from 'sweetalert'

// custom component

// api call
import UserAPI from '@/api/UserAPI'

export default {
  name: 'FormChangePassword',
  props: ['user'],
  components: {
  },
  data () {
    return {
      form_data: {
        _id: this.user._id,
        old_pw: '',
        new_pw: '',
        confirm: ''
      },

      errors: []
    }
  },
  methods: {
    // PREREQUISITES
    childData (id, value) {
      // catch value from custom form template
      this.form_data[id] = value
    },
    // END PREREQUISITES

    // HTTP REQUEST
    updatePWCS: async function () {
      try {
        let response = await UserAPI.updatePWCS(this.form_data)

        swal({
          title: response.data,
          icon: 'success',
          button: {
            text: 'Ok'
          }
        })

        this.form_data._id = this.user._id
        this.form_data.old_pw = ''
        this.form_data.new_pw = ''
        this.form_data.confirm = ''
      } catch (error) {
        let msg = error.response.data
        swal({
          title: 'Failed',
          text: msg,
          icon: 'error',
          button: {
            text: 'Ok'
          },

          closeOnClickOutside: false,
          closeOnEsc: false
        })
      }
    }
    // END HTTP REQUEST
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/templates/FormChangePassword/FormChangePassword.vue